import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const initialState = {
  id: 1,
  name: '',
  logo: '',
  menus: [],
  matters: [],
  direccion_completa: '',
  code: '',
  business_hours: null,
  cafeteria_hours: null,
  telefono: '',
  email: '',
  redes_sociales: {},
  apps_urls: {},
  favicon: '',
  data: null,
  descripcion_pub: '',
  paypal_sandbox: null,
  paypal_production: null,
  latitude: '',
  longitude: '',
  pais: '',
  localidad: '',
  has_slider: false,
  has_events: false,
  has_blog: false,
  has_subscription: false,
  theme: '',
  claimsText: '',
  refundText: '',
  fiscal_name: null,
  colour: '#000000',
  direccion: '',
  have_import_orders: false,
  merchant_code: '999008881',
  terminal: '1',
  cancel_order_instead_delete: false,
  store_photo: null,
  is_single_company: false,
  web_url: '',
  slug: '',
  brandLogo: '',
  languages: [
    {
      code_iso2: 'es',
      nombre: 'Español',
    },
    {
      code_iso2: 'en',
      nombre: 'Inglés',
    },
    {
      code_iso2: 'fr',
      nombre: 'Francés',
    },
    {
      code_iso2: 'ca',
      nombre: 'Catalán',
    },
    {
      code_iso2: 'eu',
      nombre: 'Euskera',
    },
    {
      code_iso2: 'gl',
      nombre: 'Gallego',
    }
  ],
  faqsTotals: [],
  mainLists: [],
  shipping_cost: 3.80,
  shipping_cost_islands: 12.00,
  min_purchase_for_free_shipping: null,
  enabled_countries: [],
  home_url: '',
  home_image: '',
  bank_account: ''
};

export const useCompanyStore = create(
  persist(
    (set) => ({
      ...initialState,

      loadMetaCompany: (payload) => {
        const {
          id,
          name,
          logo,
          menu_json,
          matters,
          direccion_completa,
          code,
          business_hours,
          cafeteria_hours,
          telefono,
          email,
          redes_sociales,
          apps_urls,
          favicon,
          data,
          descripcion_pub,
          paypal_sandbox,
          paypal_production,
          latitude,
          longitude,
          pais,
          localidad,
          has_slider,
          has_events,
          has_blog,
          has_subscription,
          theme,
          claimsText,
          refundText,
          fiscal_name,
          colour,
          direccion,
          have_import_orders,
          merchant_code,
          terminal,
          cancel_order_instead_delete,
          store_photo,
          web_url,
          slug,
          languages,
          shipping_cost,
          shipping_cost_islands,
          min_purchase_for_free_shipping,
          enabled_countries,
          is_single_company,
          home_url,
          home_image,
          bank_account
        } = payload;

        set({
          id,
          name,
          logo,
          menus: menu_json,
          matters,
          direccion_completa,
          code,
          business_hours,
          cafeteria_hours,
          telefono,
          email,
          redes_sociales,
          apps_urls,
          favicon,
          data,
          descripcion_pub,
          paypal_sandbox,
          paypal_production,
          latitude,
          longitude,
          pais,
          localidad,
          has_slider,
          has_events,
          has_blog,
          has_subscription,
          theme,
          claimsText,
          refundText,
          fiscal_name,
          colour,
          direccion,
          have_import_orders,
          merchant_code,
          terminal,
          cancel_order_instead_delete,
          store_photo,
          web_url,
          slug,
          languages,
          shipping_cost: Number(shipping_cost) || 3.8,
          shipping_cost_islands: Number(shipping_cost_islands) || 12.0,
          min_purchase_for_free_shipping: Number(min_purchase_for_free_shipping) || null,
          enabled_countries,
          is_single_company,
          home_url,
          home_image,
          bank_account
        });
      },

      setMainLists: (payload) => {
        set({ mainLists: payload });
      }
    }),
    {
      name: 'company-storage',
      partialize: (state) => ({
        id: state.id,
        name: state.name,
        logo: state.logo,
        menus: state.menus,
        matters: state.matters,
        direccion_completa: state.direccion_completa,
        code: state.code,
        business_hours: state.business_hours,
        cafeteria_hours: state.cafeteria_hours,
        telefono: state.telefono,
        email: state.email,
        redes_sociales: state.redes_sociales,
        apps_urls: state.apps_urls,
        favicon: state.favicon,
        data: state.data,
        descripcion_pub: state.descripcion_pub,
        paypal_sandbox: state.paypal_sandbox,
        paypal_production: state.paypal_production,
        latitude: state.latitude,
        longitude: state.longitude,
        pais: state.pais,
        localidad: state.localidad,
        has_slider: state.has_slider,
        has_events: state.has_events,
        has_blog: state.has_blog,
        has_subscription: state.has_subscription,
        theme: state.theme,
        claimsText: state.claimsText,
        refundText: state.refundText,
        fiscal_name: state.fiscal_name,
        colour: state.colour,
        direccion: state.direccion,
        have_import_orders: state.have_import_orders,
        merchant_code: state.merchant_code,
        terminal: state.terminal,
        cancel_order_instead_delete: state.cancel_order_instead_delete,
        store_photo: state.store_photo,
        is_single_company: state.is_single_company,
        web_url: state.web_url,
        slug: state.slug,
        brandLogo: state.brandLogo,
        languages: state.languages,
        faqsTotals: state.faqsTotals,
        mainLists: state.mainLists,
        shipping_cost: state.shipping_cost,
        shipping_cost_islands: state.shipping_cost_islands,
        min_purchase_for_free_shipping: state.min_purchase_for_free_shipping,
        enabled_countries: state.enabled_countries,
        home_url: state.home_url,
        home_image: state.home_image,
        bank_account: state.bank_account
      })
    }
  )
);
